import { render, staticRenderFns } from "./SecurityGuards.vue?vue&type=template&id=1efd6f7d&scoped=true&"
import script from "./SecurityGuards.vue?vue&type=script&lang=js&"
export * from "./SecurityGuards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd6f7d",
  null
  
)

export default component.exports